import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';

import { ClienteAnaliseMercadoRevisaoStatusBadgeComponent } from './cliente-analise-mercado-revisao-status-badge.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ClienteAnaliseMercadoRevisaoStatusBadgeComponent
    ],
    exports: [
        ClienteAnaliseMercadoRevisaoStatusBadgeComponent
    ]
})
export class ClienteAnaliseMercadoRevisaoStatusBadgeModule { }
